import {Component, OnInit, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import * as screenfull from 'screenfull';
import {UserblockService} from '../sidebar/userblock/userblock.service';
import {SettingsService} from '../../core/settings/settings.service';
import {MenuService} from '../../core/menu/menu.service';
import {AuthenticationService} from '../../shared/services/authentication.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
    standalone: false
})
export class HeaderComponent implements OnInit {

  menuItems = []; // for horizontal layout

  isNavSearchVisible: boolean;
  @ViewChild('fsbutton', {static: false}) fsbutton;  // the fullscreen button

  constructor(public menu: MenuService,
              public userBlockService: UserblockService,
              private authenticationService: AuthenticationService,
              public settings: SettingsService) {
    this.menuItems = menu.getMenu().slice(0, 4); // for horizontal layout
  }

  ngOnInit() {
    this.isNavSearchVisible = false;
  }

  toggleUserBlock(event) {
    event.preventDefault();
    this.userBlockService.toggleVisibility();
  }

  toggleOffSidebar() {
    this.settings.layout.offsidebarOpen = !this.settings.layout.offsidebarOpen;
  }

  toggleCollapsedSidebar() {
    this.settings.layout.isCollapsed = !this.settings.layout.isCollapsed;
  }

  isCollapsedText() {
    return this.settings.layout.isCollapsedText;
  }

  toggleFullScreen(event) {
    if (screenfull.isEnabled) {
      screenfull.toggle();
    }
    // Cambiar el ícono según el estado (sin jQuery)
    const em = this.fsbutton?.nativeElement?.querySelector('em');
    if (em) {
      if (screenfull.isEnabled && screenfull.isFullscreen) {
        em.classList.remove('bi-expand');
        em.classList.add('bi-compress');
      } else {
        em.classList.remove('bi-compress');
        em.classList.add('bi-expand');
      }
    }
  }

  logout() {
    this.authenticationService.logout();
  }
}
